const moment = require("moment");

module.exports = {
  DEFAULT_NUMBER: 123456,
  DEFAULT_CURRENCY: 99.9,
  DEFAULT_EMAIL: 'email@domain.com',

  getDefaultRestrictionValue: function (restrictionObject, initialContent) {
    var newContent;

    if (restrictionObject['numeric']) {
      newContent = restrictionObject['numeric']['min'] ? restrictionObject['numeric']['min'] : this.DEFAULT_NUMBER;
    } else if (restrictionObject['dictionary']) {
      var dictionaryInput = $('.restrictions').find('[data-name="dictionary"]').find('.bootstrap-tagsinput>input');
      dictionaryInput.val(_.contains(restrictionObject['dictionary'].list, initialContent) ? '' : initialContent);
    } else if (restrictionObject['date']) {
      newContent = restrictionObject['date']['daterange'] ? restrictionObject['date']['daterange']['start'] : moment(new Date()).format('MM/DD/YY');

      if (restrictionObject['date']['dateformat']) {
        newContent = moment(newContent, 'MM/DD/YY').format(restrictionObject['date']['dateformat']);
      }
    } else if (restrictionObject['currencies']) {
      if (restrictionObject['currencies']['min']) {
        newContent = restrictionObject['currencies']['min'];
      } else if (restrictionObject['currencies']['max']) {
        newContent = restrictionObject['currencies']['max'];
      } else {
        newContent = this.DEFAULT_CURRENCY;
      }

      if (restrictionObject['currencies']['currency']) {
        newContent = restrictionObject['currencies']['currency'] + newContent;
      }
    } else if (restrictionObject['email']) {
      newContent = this.DEFAULT_EMAIL;
    }

    return newContent;
  }
};
